import { useTranslation } from "react-i18next";
import { ActionsDropdown, ActiveIndicator } from "../../ui";

const TaxListItem = ({
  index,
  item,
  lang,
  isRTL,
  editHandler,
  setSelectedItemId,
  setDeleteModalOpen,
}) => {
  const { t } = useTranslation("global");
  const taxName = lang === "ar" ? item.tax_name_ar?.trim() : item.tax_name_en?.trim();
  const isArabic = lang === "ar";

  const getTaxTypeDisplay = (taxType) => {
    if (!taxType || taxType === "ALL") return t("vat.taxTypeAll", "ALL (الكل)");
    if (taxType === "SALES") return t("vat.taxTypeSales", "SALES (المبيعات)");
    if (taxType === "PURCHASE") return t("vat.taxTypePurchase", "PURCHASE (المشتريات)");
    return taxType;
  };

  const getAccountNameFromCache = (accountNo) => {
    if (!accountNo) return "";
    try {
      const accounts = JSON.parse(localStorage.getItem("accounts") || "[]");
      const findAccountName = (tree, no) => {
        for (const node of tree) {
          if (String(node.account_no) === String(no)) {
            return isArabic
              ? (node.name_ar || node.name_en || "")
              : (node.name_en || node.name_ar || "");
          }
          if (node.childs && Array.isArray(node.childs)) {
            const found = findAccountName(node.childs, no);
            if (found) return found;
          }
        }
        return "";
      };
      return findAccountName(accounts, accountNo);
    } catch {
      return "";
    }
  };

  const getAccountDisplay = () => {
    const accountNo = item?.account_no || "";
    const accountName = getAccountNameFromCache(accountNo);
    if (!accountNo && !accountName) {
      return <span className="text-gray-400">—</span>;
    }
    return (
      <div className="flex items-center justify-center gap-1">
        {accountNo && (
          <span className="text-xs text-gray-500 font-semibold bg-gray-100 px-1.5 py-0.5 rounded">
            {accountNo}
          </span>
        )}
        {accountNo && accountName && <span className="text-gray-300 text-xs">|</span>}
        {accountName && (
          <span className="font-semibold text-[#251658] text-xs">
            {accountName}
          </span>
        )}
      </div>
    );
  };

  return (
    <div className="flex gap-2 px-3 py-1 border-t justify-between items-center text-xs text-slate-600 hover:font-bold hover:bg-slate-100">
      <div className="w-16 text-center">{index + 1}</div>
      <div className="flex-1">{taxName}</div>
      <div className="w-36 text-center">{item.tax_value}%</div>
      <div className="w-36 text-center">{getTaxTypeDisplay(item.tax_type)}</div>
      <div className="w-48 text-center">{getAccountDisplay()}</div>
      <div className="w-36 text-center">
        <div className="w-36 flex justify-center items-center">
          <ActiveIndicator active={item.is_active} />
        </div>
      </div>
      <div className="w-36 text-center">
        <ActionsDropdown
          isRTL={isRTL}
          onEdit={() => editHandler(item.id)}
          onDelete={() => {
            setSelectedItemId(item.id);
            setDeleteModalOpen(true);
          }}
          itemId={item.id}
          editText={t("common.edit")}
          deleteText={t("common.delete")}
        />
      </div>
    </div>
  );
};

export default TaxListItem;
